/* eslint-disable no-nested-ternary */
import styled from "styled-components/macro";
import { LabelString, LabelDollarFormatted, ModuleAccordionSummary, LabelStringColumn, ToggleSelect } from "@loanbossinc/component-library";

// Dnd container styles
export const StyledDndItem = styled.div`
  width: 100%;
  border-bottom: 1px solid #dadce0;

  &&:last-child {
    border-bottom: none;
  }
`;

export const NoLineItemWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0.5em 1em;
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
`;

// NOI calculation dashboard styles
export const StyledLineItemRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: ${props => (props.isMultipleProperties || !props.isComparison ? "none" : "1px solid #DADCE0")};
  box-sizing: border-box;
`;

export const StyledLineItemRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const StyledSinglePropComparison = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background: #fafafa;
  height: 90px;
`;

export const StyledValue = styled.div`
  padding-right: ${props => (props.isMultiple ? "0" : "24px")};
  min-width: 130px;

  & span {
    font-family: Roboto Mono !important;
  }
`;

export const StyledLineItemName = styled(LabelString)`
  flex-grow: 1;
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px !important;
  line-height: 19px;
  padding-left: 8px;
  width: min-content;
`;

export const StyledAccordionSummary = styled(ModuleAccordionSummary)`
  padding: 0 1em 0 0 !important;

  &&.title-section {
    align-items: center !important;
  }
`;

export const StyledLabelCont = styled.div`
  width: 144px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: ${props => props.pl};
`;

export const StyledLabel = styled.div`
  background: #ffffff;
  border: 1px solid #dadce0;
  box-sizing: border-box;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000000;
`;

export const StyledLabelStringColumn = styled(LabelStringColumn)`
  padding: 2px 12px !important;
  color: #000000;
`;

export const SubItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  justify-content: space-evenly;
  padding-right: 24px;
  padding-left: 8px;
`;

export const SubItem = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledLabelString = styled(LabelString)`
  font-style: normal !important;
  font-weight: ${props => (props.$bold ? "bold !important" : "normal !important")};
  font-size: ${props => `${props.$size || "14px"} !important`};
  line-height: 16px !important;
  color: ${props => (props.$ishighlighted ? "#0F9AD6 !important" : "#5f6368 !important")};
`;

export const StyledLabelDollarFormatted = styled(LabelDollarFormatted)`
  font-style: normal !important;
  font-weight: ${props => (props.$bold ? "900 !important" : "200 !important")};
  font-size: ${props => `${props.$size || "13px"} !important`};
  line-height: 18px !important;
  color: ${props => (props.$ishighlighted ? "#0F9AD6 !important" : props.$bold ? "#383a3d !important" : "#5f6368 !important")};
  font-family: Roboto Mono !important;

  & span {
    padding: 0;
    text-align: right;
  }
`;

export const MultiplePropDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em 24px 0 1em;
  box-sizing: border-box;
  width: 100%;
  background: #fafafa;
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #5f6368;
`;

export const MultiplePropValueRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1em;
  width: 100%;
`;

export const MultiplePropComparisonGroupWrapper = styled.div`
  width: 68%;
  align-self: flex-end;
  display: flex;
  flex-direction: column;
  padding: 0.5em 0;
`;

export const MultiplePropComparisonGroupHeader = styled.div`
  font-weight: bold;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dadce0;
  width: 100%;
`;

export const MultiplePropComparisonGroupRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 0.7em;
  padding-top: 0.7em;
`;

export const StyledToggleSelect = styled(ToggleSelect)`
  & button {
    width: 100px;
  }

  & button[aria-pressed="true"] {
    pointer-events: none;
  }
`;

export const SummaryWrapper = styled.div`
  margin: 3.5em 0;
  box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
`;

export const PaddedWrapper = styled.div`
  padding: ${props => props.padding || "1 em"};
`;
